import moment from "moment";
import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Card } from "reactstrap";

import { ReactComponent as BackIcon } from "assets/img/svg/BackArrow.svg";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import {
    successToast,
    failureToast,
} from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import ALoader from "views/pages/manage/common/a-loader";
import { EDIT_SLAB_FORM_FIELDS, chipStyle, labelStyle, updateSlabDetails, convertMinutesToHHMM } from "./constants";
import InvigilatorPaymentSlab from "./paymentSlab/InvigilatorPaymentSlab";
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import { paymentSlabStatusOptions, fetchSlabDetails } from "../helper";
const InvigilatorViewEditSlab = () => {

    const { id } = useParams();
    const history = useHistory();
    const [slab, setSlab] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [slabUpdating, setSlabUpdating] = useState(false);
    const [error, setError] = useState(null);
    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 0,
        totalPage: 0,
        totalRecords: 0,
    });
    const [currPageSize, setCurrentPageSize] = useState(50);
    const [form, setForm] = useState({ ...EDIT_SLAB_FORM_FIELDS });


    const handleForm = (key, value) => {
        setForm((prev) => ({ ...prev, [key]: value }));
    };

    const updateSlabHandler = async () => {
        try {
            setSlabUpdating(true);
            const payload = {
                status: form?.status?.value,
                effectiveDate: moment(form?.effectiveDate).format("YYYY-MM-DD[T]HH:mm:ss")
            }
            const resp = await updateSlabDetails(id, payload);
            if (resp?.code === 200) {
                successToast("Slab details successfully updated");
                setEditMode(false);
                fetchDetails();

            }
        } catch (e) {
            console.log(e);
            failureToast("Failed to update status");
        } finally {
            setSlabUpdating(false);
            setEditMode(false);
        }
    }


    const fetchDetails = async () => {
        try {
            setIsLoading(true);
            setError(null);

            const data = await fetchSlabDetails(id);
            if (data) {
                const masterData = data.master;
                const formattedDate = moment(masterData?.effectiveDate);
                const statusObj = paymentSlabStatusOptions?.find(
                    (s) => s?.value === masterData?.status
                );

                const rowsData = (data.rows || []).map((row,idx) => ({
                    ...row,
                    srNo: idx+1,
                    minutes: row?.countFrom // getting hours and minutes in total minutes
                }));

                setSlab({
                    ...masterData,
                    effectiveDate: formattedDate.format("DD/MM/YYYY"),
                    status: statusObj,
                    bu: masterData.businessUnit,
                    year: masterData.year,
                });

                setForm({
                    status: statusObj,
                    effectiveDate: formattedDate,
                });
                setRows(rowsData);
            } else {
                setError("Slab not found");
            }

        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);

        }
    }

    useEffect(() => {
        fetchDetails();
    }, [id])


    if (isLoading)
        return (
            <div className="p-4">
                <ALoader />
            </div>
        );

    if (error || !slab) {
        return (
            <div className="p-4">
                <div className="d-flex align-items-center mb-3">
                    <BackIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => history.goBack()}
                    />
                    <h3 className="heading-3 mb-0 ml-2">Slab setup</h3>
                </div>
                <Card className="p-5 text-center">
                    <div style={{ padding: "40px 20px" }}>
                        <h4 className="text-muted mb-3">Slab Not Found</h4>
                        <p className="text-secondary">
                            {error || "The requested payment slab could not be found."}
                        </p>
                        <button
                            className="btn btn-primary mt-3"
                            onClick={() => history.goBack()}
                        >
                            Go Back
                        </button>
                    </div>
                </Card>
            </div>
        );
    }

    const chips = [
        { label: "Country", value: slab.country },
        { label: "State", value: slab.state },
        { label: "BU", value: slab.bu },
    ];

    //write a useEffect in which after api is loaded set default values for slab 


    return (
        <div className="p-4">
            <div className="d-flex align-items-center mb-3">
                <BackIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => history.goBack()}
                />
                <h3 className="mb-0 ml-2 heading-3 text-bold">Slab setup</h3>
                <div className="ml-auto d-flex align-items-center">
                    {chips.map((chip) => (
                        <span key={chip.label} style={chipStyle}>
                            <span style={labelStyle}>{chip.label}:</span>
                            <span style={{ fontWeight: 600 }}>{chip.value}</span>
                        </span>
                    ))}
                </div>
            </div>

            <Card className="p-4 mb-4">
                <h3 className="text-bold mb-4">Slab setup</h3>

                <div className="d-flex align-items-end" style={{ gap: 40 }}>

                    <div style={{ width: 200 }}>
                        <CustomDatePickerV2
                            placeHolder="From"
                            value={form?.effectiveDate}
                            width={"18px"}
                            label="Effective date"
                            handler={(index, date) => {
                                handleForm("effectiveDate", moment(date));
                            }}
                            disabled={!editMode}
                        />
                    </div>

                    <div style={{ width: 200 }}>
                        <AAutoComplete
                            items={paymentSlabStatusOptions}
                            currentValue={form?.status}
                            handleChange={(value) => handleForm("status", value)}
                            isMulti={false}
                            label="Status"
                            height="36px"
                            isDisabled={!editMode}
                        />
                    </div>

                    <div className="d-flex align-items-center mt-3" style={{ gap: "16px" }}>
                        {editMode ? (
                            <AButton
                                variant="primary_filled"
                                size="sm"
                                onClick={updateSlabHandler}
                                disabled={slabUpdating}
                                updatedStyle={{
                                    width: "120px", height: "37px"
                                }}

                            >
                                Save
                            </AButton>
                        ) : (
                            <AButton
                                variant="primary_filled"
                                size="xs"
                                updatedStyle={{
                                    width: "120px", height: "37px"
                                }}

                                onClick={() => setEditMode(true)}
                            >
                                Edit
                            </AButton>
                        )}
                    </div>

                </div>
            </Card>

            <InvigilatorPaymentSlab
                slabId={id}
                rows={rows}
                setRows={setRows}
                fetchDetails={fetchDetails}
            />
        </div>
    );
}

export default InvigilatorViewEditSlab